export default {
  scheme: 'Schemat',
  schemeName: 'Nazwa schematu załadunku',
  description: 'Opis',
  images: 'Obrazy',
};
